import { render, staticRenderFns } from "./MiLogs.vue?vue&type=template&id=15252dcd&scoped=true"
import script from "@/components/mi-logs/MiLogs.ts?vue&type=script&lang=ts&external"
export * from "@/components/mi-logs/MiLogs.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/mi-logs/mi-logs.scss?vue&type=style&index=0&id=15252dcd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15252dcd",
  null
  
)

export default component.exports